<template lang="pug">
  div
    SingleNumWrapper(
      :chartType="'reqsumnum'"
      :chartTitle="$t('dashboard.totalRequestCount')"
      :numeralFormat="'0.00a'"
      :maxFontSize="'42px'"
      :withCard="withCard"
    )
    LineChartWrapper(
      :chartType="'reqlinechart'"
      :chartDataSetLabel="[$t('dashboard.requestCount')]"
      :titleDisplay="false"
      :withCard="withCard"
      :chartWidth="600"
      :chartHeight="100"
      :xAxesDisplay="false"
      :yAxesDisplay="false"
      :legendDisplay="false"
      :lineBorderColors="[colorScheme.blue.border]"
      :lineBackgroundColors="[colorScheme.blue.fillTransparent]"
      :withPropRawBtn="false"
      )
</template>
<script>
import SingleNumWrapper from "@/components/dashboard/SingleNumWrapper";
import LineChartWrapper from "@/components/dashboard/LineChartWrapper";

import colorScheme from "@/data/colorScheme";

export default {
    components: { SingleNumWrapper, LineChartWrapper },
    props: {
        dateRange: {
            type: String,
            default: "1"
        },
        customTimeRange: {
            type: Array,
            default: () => ["", ""]
        },
        withCard: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            colorScheme: colorScheme
        };
    }
};
</script>



// WEBPACK FOOTER //
// src/components/HomePage/OverviewCard.vue